export default function CarouselSection() {
  const topics = [
    {
      title: '暑期档票房争霸战',
      desc: '多部国产大片正面交锋，票房走势扑朔迷离，各家片方营销手段层出不穷',
      tag: '影视',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20summer%20movie%20box%20office%20theme%20with%20cinema%20marquee%20and%20warm%20golden%20dramatic%20lighting%2C%20coral%20red%20accents%2C%20vibrant%20entertainment%20atmosphere%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=carousel-01&orientation=landscape',
    },
    {
      title: '新晋流量格局变化',
      desc: '新生代艺人纷纷崛起，粉丝经济模式迭代，娱乐圈权力版图正在悄然重塑',
      tag: '人物',
      img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20celebrity%20culture%20abstract%20theme%20with%20spotlight%20stage%20and%20warm%20coral%20amber%20gradient%2C%20dynamic%20energy%2C%20editorial%20photography%20style%2C%20no%20faces&width=800&height=500&seq=carousel-02&orientation=landscape',
    },
    {
      title: '综艺创新模式探索',
      desc: '各大平台纷纷推出原创综艺，互动形式与内容深度成为差异化竞争的关键',
      tag: '综艺',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20production%20studio%20with%20colorful%20warm%20stage%20lights%2C%20creative%20set%20design%2C%20coral%20and%20gold%20tones%2C%20editorial%20style%2C%20vibrant%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
    },
    {
      title: '音乐产业回暖信号',
      desc: '线下演唱会全面复苏，数字专辑销量屡创新高，音乐人迎来最好时代',
      tag: '音乐',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20concert%20stage%20with%20warm%20dramatic%20lighting%20and%20large%20audience%20silhouette%2C%20golden%20and%20coral%20warm%20atmosphere%2C%20editorial%20photography%2C%20no%20recognizable%20faces&width=800&height=500&seq=carousel-04&orientation=landscape',
    },
    {
      title: '短视频造星新势力',
      desc: '抖音快手持续输出网红转型艺人，短视频平台成为娱乐圈新的人才输送通道',
      tag: '趋势',
      img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20social%20media%20content%20creation%20theme%20with%20smartphone%20and%20ring%20light%2C%20warm%20coral%20and%20gold%20tones%2C%20contemporary%20digital%20culture%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    },
  ];

  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          焦点专题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.slice(0, 2).map((topic, i) => (
            <div key={i} className="lg:col-span-1 bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative h-48 overflow-hidden">
                <img src={topic.img} alt={topic.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">{topic.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading text-foreground-950 mb-2">{topic.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{topic.desc}</p>
              </div>
            </div>
          ))}
          {topics.slice(2).map((topic, i) => (
            <div key={i + 2} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative h-48 overflow-hidden">
                <img src={topic.img} alt={topic.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-foreground-950 whitespace-nowrap">{topic.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading text-foreground-950 mb-2">{topic.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}